import { ReactNode } from 'react';
import { FormattedMessage } from 'dibs-react-intl';

import { useBuyerIncentivesV3ClientVariants } from './buyerIncentivesV3Helpers';
import { BuyerProtection } from './BuyerProtection';

export const useCoreBuyerIncentivesV3 = ({
    isMobile,
}: {
    isMobile: boolean;
}): [ReactNode, ReactNode, ReactNode] | null => {
    const isVariant = useBuyerIncentivesV3ClientVariants({ isMobile });

    if (isVariant) {
        return [
            <FormattedMessage
                id="useCoreBuyerIncentives.authenticityGuarantee"
                defaultMessage="Authenticity Guarantee"
            />,
            <BuyerProtection isMobile={isMobile} />,
            <FormattedMessage
                id="useCoreBuyerIncentives.cancelationPolicy"
                defaultMessage="24-Hour Cancellation"
            />,
        ];
    }

    return null;
};
